var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroadbandInstallIconAb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.887 48.373C39.4749 48.3737 40.0405 48.5988 40.468 49.0024C40.8955 49.4061 41.1528 49.9577 41.1873 50.5447C41.2217 51.1316 41.0308 51.7096 40.6534 52.1605C40.276 52.6114 39.7407 52.9011 39.1569 52.9706L38.887 52.9867H20.4322C19.8442 52.9861 19.2787 52.7609 18.8511 52.3573C18.4236 51.9537 18.1663 51.402 18.1318 50.8151C18.0974 50.2281 18.2883 49.6501 18.6657 49.1993C19.0431 48.7484 19.5784 48.4586 20.1623 48.3892L20.4322 48.373H38.887ZM48.1144 23.7666C49.2783 23.7662 50.3995 24.2058 51.2529 24.9973C52.1064 25.7888 52.6292 26.8736 52.7165 28.0343L52.7281 28.3803V41.4525C52.7284 42.6164 52.2888 43.7376 51.4974 44.591C50.7059 45.4445 49.6211 45.9673 48.4604 46.0546L48.1144 46.0662H11.2048C10.0408 46.0665 8.91968 45.6269 8.06618 44.8355C7.21269 44.044 6.6899 42.9592 6.6026 41.7985L6.59106 41.4525V28.3803C6.5907 27.2163 7.0303 26.0952 7.82176 25.2417C8.61322 24.3882 9.69803 23.8654 10.8587 23.7781L11.2048 23.7666H48.1144ZM48.1144 28.3803H11.2048V41.4525H48.1144V28.3803Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1648 8.46734L49.6547 25.9608",
    stroke: "white",
    strokeWidth: 4.99817,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadbandInstallIconAb);
export default __webpack_public_path__ + "static/media/broadbandInstallIcon_ab.e78b520554d72caa59a2b01a7e1224a8.svg";
export { ForwardRef as ReactComponent };